<template>
    <div class="user_profile_wrap">
        <div class="title">{{get_local_string.string_41}}</div>
        <form  @submit.prevent="update_profile()">
         <b-field :label="get_local_string.string_48" label-position="on-border" type="is-light">
            <b-input v-model="new_user.name" :value="user.name" @keyup.native="on_write_name($event)" ></b-input>
            <!-- :value="user.name" -->
        </b-field>
         <b-field :label="get_local_string.string_49" label-position="on-border" type="is-light">
            <b-input :value="user.mobile" :disabled="true"></b-input>
        </b-field>
         <b-field :label="get_local_string.string_50" label-position="on-border" type="is-light">
            <b-input :value="user.email" :disabled="true"></b-input>
        </b-field>
        <b-button :disabled="disabled" :loading="loading" class="savebtn"  native-type="submit" type="is-success">{{get_local_string.string_51}}<ion-icon name="checkmark-done-circle-outline"></ion-icon></b-button>
        </form>
    </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex';
export default {
    name:'userprofile',
     data() {
        return {
            new_user:{
                name:''
            },
             errorMsg:'',
             disabled:true,
             loading:false
        }
    },
    computed:{
    ...mapGetters({
        user:'auth/user',
        get_update_profile_name:'get_update_profile_name',
         get_local_string:'get_local_string'
    })
   },
   methods:{
       ...mapActions({
           updateprofile:'updateprofile',
       }),
       update_profile(){
           this.loading = true;
           this.updateprofile(this.new_user.name).then(()=>{
               if(this.get_update_profile_name == 200){
                  this.errorMsg = `<b>Profile Name Change successfully</b>`;
                  this.success();
                  this.loading = false;
                 }
                 else{
                     this.errorMsg =`<b>Something Error to Change Name !!</b>`;
                      this.danger();
                      this.loading = false;
                 }
           });
       },
       on_write_name(event){
           if(event.srcElement.value=='')
           {
               this.disabled = true;
           }
           else{
               this.disabled = false;
           }
       },
       setValue(){
           this.new_user.name = this.user.name;
       },
         // MSG ALERT
        success() {
          const notif = this.$buefy.notification.open({
              duration: 4000,
              message: this.errorMsg,
              position: 'is-bottom-right',
              type: 'is-success',
              hasIcon: true
          })
          notif.$on('close', () => {
              // this.$buefy.notification.open('Custom notification closed!')
          }
          )
      },
        danger() {
                const notif = this.$buefy.notification.open({
                    duration: 4000,
                    message: this.errorMsg,
                    position: 'is-bottom-right',
                    type: 'is-danger',
                    hasIcon: true
                })
                notif.$on('close', () => {
                    // this.$buefy.notification.open('Custom notification closed!')
                }
                )
            },
   },
   mounted(){
       this.setValue();
   }
}
</script>
<style lang="scss" >
.user_profile_wrap{
    form{
    background-color: transparent;
    position: relative;
    padding: 20px;
    border-radius: 20px;
    }
    .title{
    font-size: 30px;
    position: relative;
    display: inline-block;
    padding-top: 10px;
    color: #c1a179;
    border-bottom: 3px solid #c1a179;
    padding-bottom: 6px;
    }
       .input {
    background-color: #cbcbcb;
    border-color: #3f3d3d33;
    border-radius: 4px;
    color: #000;
}
.field.is-floating-label .label:before{
     background-color: #525252 !important;
}

.field.is-floating-label .label:before{
     background-color: #cbcbcb !important;
}
  [disabled].input, fieldset[disabled]{
    background-color: #3f3d3d33;
    color: rgb(99, 99, 99);
    border-color: #3f3d3d33;
    -webkit-box-shadow: none;
    box-shadow: none;
    .label:before {
    background-color: #afaeae !important;
}
}

.savebtn{
    font-weight: 600;
    span{
        display: flex;
        align-items: center;
        ion-icon{
        margin-left: 7px;
         font-size: 22px;
        }
    }
}
    form{
        max-width: 600px;
    }

 .field{
            margin-bottom: 20px !important; 
        }
}
</style>